import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = { class: "form-fields-wrapper" }
const _hoisted_3 = { class: "form-buttons-wrapper" }

import { $api } from "@/services/api";
import { reactive, ref } from "vue";
import type { FieldSchema, FormSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import NextButton from "@/components/shared/NextButton.vue";
import useValidation from "@/use/validation";
import type { Applicant } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { StipulationInputRequest } from "@/models/api";

interface Props {
  applicant: Applicant;
  stip: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DateOfBirthInput',
  props: {
    applicant: {},
    stip: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { validateForm } = useValidation();

let personalInfo = ref({} as any);

const submittingData = ref<boolean>(false);

const schema = reactive<FormSchema>({
  dateOfBirth: {
    name: "dateOfBirth",
    type: "date",
    subtype: "dob",
    label: "Date of Birth",
    required: true,
    errorMessage: "Date of Birth is required.",
  } as FieldSchema,
} as FormSchema);

async function submit() {
  submittingData.value = true;
  const valid = validateForm(schema, personalInfo.value);
  if (valid) {
    const request = {
      applicationStipulationId: props.stip?.id,
      applicationId: props?.stip?.applicationId,
      dobInput: { dateOfBirth: personalInfo.value?.dateOfBirth },
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(props?.stip?.applicationId, request);

    if (response?.id && response?.id > 0) {
      // updates stip status to pending
      let updatedDateOfBirthVerificationStip = props.stip;
      updatedDateOfBirthVerificationStip.stipulationStatusId = response.stipulationStatusId;
      updatedDateOfBirthVerificationStip.stipulationStatusName = response.stipulationStatusName;
      
			emit("success", updatedDateOfBirthVerificationStip);

      submittingData.value = false;
    } else {
      submittingData.value = false;
    }
  } else {
    submittingData.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseFormField, {
        modelValue: _unref(personalInfo).dateOfBirth,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(personalInfo).dateOfBirth) = $event)),
        schema: schema.dateOfBirth,
        validateOnChange: true
      }, null, 8, ["modelValue", "schema"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(NextButton, {
        onClick: submit,
        text: "Submit"
      })
    ])
  ]))
}
}

})